//Testing Modal

$('#test_btn').click(function() {
    $('#testing_modal').addClass('active');
})

$('#close_testing_modal').click(function() {
    $('#testing_modal').removeClass('active');
})

$('input[name="testing-or-buy"]').change(function(e) {
    if(e.target.id === 'testing-option') {
        $('body').addClass('testing-active');
    } else {
        $('body').removeClass('testing-active');
    }
})


//Variant Selector
var $product = $('#testing-product')
if($product.length > 0){
    var productSingleObject = JSON.parse($product.find('.product-json-testing')[0].innerHTML)

    function getTestingProductOption ( $product ) {

        /* ----
            Get current variant
            ---- */

        var optionArray = [];

        $product.find('form select.product-variants-testing').each(function(){
            optionArray.push($(this).find(':selected').val())
        });


        return optionArray;

    }

    function initTestingProductVariantChange (productSingleObject, $product) {

        var variant = null,
            options = getTestingProductOption( $product );

        productSingleObject.variants.forEach(function(el){

            if ( $(el)[0].options.equals(options) ) {

                variant = $(el)[0];
            }

        });

        productTestingSelectCallback(variant, $product);


    }

    function productTestingSelectCallback (variant, $product) {
        if (variant) {

            // Set cart value id
            $product.find('#variant_select_testing').find('option[value="' + variant.id + '"]').prop('selected', true);
        }
    }

    initTestingProductVariantChange ( productSingleObject, $product )

    $('.product-variants-testing').change(function() {
        initTestingProductVariantChange ( productSingleObject, $product );
    });
}


//product collection isotope

var $grid = $(".isotope-products")

$grid.isotope({ layoutMode: 'fitRows' })


//product page hide default select
$('#variant_select_testing').parent().css('display', 'none')

//cart quantity reload on keyup
let timer = null
$('.count').keyup(function(){
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
    if (this.value) {
        timer = setTimeout(() => {
            $('#cart-form').submit();
        }, 800);
    }
})


$('.testing-chooser-option').click(function () {
    setTimeout(function () {
        $(window).trigger('resize');
    }, 100)
})

//color swatch
$('[data-showcolor-value]').click(function () {
  const optionValue = this.dataset.showcolorValue;
  const showcolorWrapper = this.closest('.showcolor')
  const $option = $('[data-showcolor-value=' + optionValue + ']');
  const $select = $option.closest('select');

  $('option', $select).prop('selected', false);
  $('[data-showcolor-value]', showcolorWrapper).removeClass('active');
  $option.prop('selected', true).addClass('active');
  $select.change();

})


//init Modal script

MicroModal.init();


// init accordion
if($('.ac-container')[0]){
  var accordion = new Accordion('.ac-container');
}

// data-afterrent-slide

const afterRent = function(afterRentObj) {
  //console.log('init', afterRentObj);
  const $afterRentTrigger = $('[data-afterrent-option]', afterRentObj);
  const $afterRentBack = $('[data-afterrent-back]', afterRentObj);
  const $afterRentHideif = $('[data-afterrent-hideif]');
  const $afterRentSlide1 = $('[data-afterrent-slide=1]', afterRentObj);
  const $afterRentSlide2 = $('[data-afterrent-slide=2]', afterRentObj);


  const url_string = window.location.href
  var url = new URL(url_string);
  var contact_posted = url.searchParams.get("contact_posted");
  if(contact_posted){
    $('.page-title').hide();
    $('[data-afterrent]').hide();
    $('.afterrent-success-message').show();
    $('[data-afterrent-showif=' + localStorage.getItem('option') + ']').show();

    return;
  }

  localStorage.removeItem('option')

  $(afterRentObj).height($afterRentSlide1.height());

  $afterRentTrigger.click(function(){
    const afterRentTriggerValue = $(this).data('afterrent-option')

    $afterRentHideif.each(function(hideif){
      if($(this).data('afterrent-hideif').indexOf(afterRentTriggerValue) > -1){
        $(this).hide();
        if($('input', this).data('required') !== undefined){
          $('input', this).attr('required',false);
        }
      } else {
        $(this).show();
        if($('input', this).data('required') !== undefined){
          $('input', this).prop('required',true);          
        }
      }
    });

    if(afterRentTriggerValue === 'keep') {
      
      $('#contactFormSubject').val('Behalten');
      localStorage.setItem('option', 'keep');

    } else if(afterRentTriggerValue === 'change') {
      
      $('#contactFormSubject').val('Andere Variante');
      localStorage.setItem('option', 'change');
    
    } else if(afterRentTriggerValue === 'return') {
    
      $('#contactFormSubject').val('Zurücksenden');
      localStorage.setItem('option', 'return');
    
    }


    $(afterRentObj).data('afterrent', 2)
    $(afterRentObj).attr('data-afterrent', 2)
    $(afterRentObj).height($afterRentSlide2.height());

  });

  //back
  $afterRentBack.click(function() {
    $(afterRentObj).data('afterrent', 1)
    $(afterRentObj).attr('data-afterrent', 1)
    $(afterRentObj).height($afterRentSlide1.height());

    $($afterRentHideif).hide();
    $('[data-afterrent-hideif="keep change return"]').show();
  });

}

$('[data-afterrent]').each(function() {
  afterRent(this);
})
